import axios from "axios";
import qs from "qs";
import Toast from 'vux/src/components/toast/index.vue'

import Vue from "vue";

import { is_weixn } from "@/utils";

import { getToken } from "@/utils/auth";
import { delRepeatHttpRequest } from "@/utils/tool";

import { externalCallFunc } from "@/utils/webviewUtils";

import { excludeMessages, serverConfig, errorMsgList } from "./httpConfig";

Vue.component("toast", Toast);

let config = {
timeout: 60 * 1000 
};

const { baseURL, microServiceURL, baseWsUrl, storeURL } = serverConfig;

const baseUrlArr = [baseURL, microServiceURL, baseWsUrl, storeURL];

const _axios = axios.create(config);

const CancelToken = axios.CancelToken;
const requestMap = new Map(); 


export const getUrlParams = url => {

let urlStr = url.split("?")[1];

let obj = {};
if (urlStr) {

let paramsArr = urlStr.split("&");
for (let i = 0, len = paramsArr.length; i < len; i++) {

let arr = paramsArr[i].split("=");
obj[arr[0]] = arr[1];
}
}

return obj;
};


_axios.interceptors.request.use(
function(config) {
const url = window.location.href;

const { user_token } = getUrlParams(url);

config.headers["user_token"] = user_token || getToken();
config.headers["app_device"] = is_weixn() ? 2 : 1;
config.headers["push_userid"] = "0";
config.headers["plat_form"] = "0"; 
config.headers["device_number"] = "0"; 

Vue.$vux.loading.show({
text: "Loading"
});


delRepeatHttpRequest(requestMap, config, qs, CancelToken);

return config;
},
function(error) {
Vue.$vux.loading.hide();

return Promise.reject(error);
}
);


_axios.interceptors.response.use(
function(resp) {
Vue.$vux.loading.hide();


requestMap.set(resp.config._keyString, false);
let code = parseInt(resp.headers["x-err-code"]) || 0;
let message = resp.headers["x-err-message"] || "";


let ocrCodeFilterArr = [
13054,
13055,
13056,
13057,
22049,
23007,
1005,
1000
];

if (
resp.status === 200 &&
resp.data.code !== 0 &&
!ocrCodeFilterArr.includes(resp.data.code)
) {
let msg = resp.data.msg || "";
if (!excludeMessages.includes(msg)) {
if (msg.indexOf("user_token") === -1) {
let flag = false;
errorMsgList.forEach(e => {
if (msg.indexOf(e) > -1) {
flag = true;
}
});
if (!flag) {
Vue.$vux.toast.text(msg, "middle");
}
}
}
} else if ([400, 500, 501].includes(resp.data.code)) {
this.$vux.toast.text(resp.data.msg, "middle");
return false;
}
if ([10000, 10001, 10002].includes(resp.data.code)) {


localStorage.clear();

externalCallFunc({
funcName: "finishWeb",
default_func: () => {

let host = window.location.host;
let list = window.location.href.split(host);
if (list.length) {
if (list[1].indexOf("code") === -1) {
localStorage.setItem("fullPathList", list[1]);
}
}
window.location.href = "/login";
}
});
}



return {
data: resp.data,
code: code,
message: message
};
},
function(error) {

if (error.config) {
requestMap.set(error.config._keyString, false);
}

Vue.$vux.loading.hide();
if (error.response && error.response.status === 500) {
Vue.$vux.toast.text("服务器无法连接，请刷新重试", "middle");
}


return Promise.reject(error);
}
);


const Api = {

request_path: baseURL,


base_path: window.location.origin,


javaGet: (url, params, baseUrIndex = 0) => {
let config = {
method: "get",
url,
params
};
config.baseURL = baseUrlArr[baseUrIndex];
return _axios(config);
},


javaPost: (url, data, baseUrIndex = 0) => {
let config = {
method: "post",
url,
data: qs.stringify(data),
headers: {
"Content-Type": "application/x-www-form-urlencoded"
}
};
config.baseURL = baseUrlArr[baseUrIndex];
return _axios(config);
},


javaJson: (url, data, baseUrIndex = 0) => {
let config = {
method: "post",
url,
data,
headers: {
"Content-Type": "application/json"
}
};
config.baseURL = baseUrlArr[baseUrIndex];
return _axios(config);
},


uploadAjax: (url, data, baseUrIndex = 0) => {



let fd = new FormData();
let file = "file";
fd.append(
`${file}`,
data[file],
new Date().getTime() + "." + data[file].type.split("/")[1]
);
let queryString = "?";
for (let key in data) {
if (![`file`].includes(key)) {
queryString += `${key}=${data[key]}&`;
}
}
queryString = queryString.substring(0, queryString.length - 1);

let config = {
method: "post",
url: url + queryString,
data: fd,
headers: {
"Content-Type": "multipart/form-data"
}
};
config.baseURL = baseUrlArr[baseUrIndex];
return _axios(config);
},


downloadAjax: (url, data, baseUrIndex = 0) => {
let config = {
method: "post",
url,
data,
responseType: "blob"
};
config.baseURL = baseUrlArr[baseUrIndex];
return _axios(config);
}
};

export default Api;



// WEBPACK FOOTER //
// ./src/api/getApi.js